const SET_BRICKLAB_USER = 'scratch-gui/bricklab-user/SET_BRICKLAB_USER';
const SET_BRICKLAB_USER_LOADING = 'scratch-gui/bricklab-user/SET_LOADING';
const SET_BRICKLAB_USER_ERROR = 'scratch-gui/bricklab-user/SET_ERROR';

const initialState = {
    user: null, // { userId, role, email, classId } or null
    loading: false,
    error: null
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_BRICKLAB_USER:
            return {
                ...state,
                user: action.user,
                loading: false,
                error: null
            };
        case SET_BRICKLAB_USER_LOADING:
            return {
                ...state,
                loading: action.loading
            };
        case SET_BRICKLAB_USER_ERROR:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        default:
            return state;
    }
};

const setBricklabUser = user => ({
    type: SET_BRICKLAB_USER,
    user
});

const setBricklabUserLoading = loading => ({
    type: SET_BRICKLAB_USER_LOADING,
    loading
});

const setBricklabUserError = error => ({
    type: SET_BRICKLAB_USER_ERROR,
    error
});

/**
 * Fetch current BrickLab user (role, userId, classId) and store in state
 * @returns {Function} thunk
 */
const fetchBrickLabUser = () => async dispatch => {
    const { getBrickLabMe, initAuthFromURL } = require('../lib/seeds-api');
    const { token } = initAuthFromURL();
    if (!token) {
        dispatch(setBricklabUser(null));
        return;
    }
    dispatch(setBricklabUserLoading(true));
    try {
        const data = await getBrickLabMe();
        if (data.success) {
            dispatch(setBricklabUser({
                userId: data.userId,
                role: data.role,
                email: data.email,
                classId: data.classId || null
            }));
        } else {
            dispatch(setBricklabUser(null));
        }
    } catch (err) {
        dispatch(setBricklabUserError(err.message || 'Failed to load user'));
        dispatch(setBricklabUser(null));
    }
};

export {
    reducer as default,
    initialState as bricklabUserInitialState,
    setBricklabUser,
    setBricklabUserLoading,
    setBricklabUserError,
    fetchBrickLabUser
};
